import React, { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { selectIsDashboardLoading } from '../../redux/dashboardSlice';
import { Copyright, PageLayout, Spinner } from '../../components';
import useStyles from './Dashboard.styles';

const Dashboard: FunctionComponent = ({
  children,
}) => {
  const classes = useStyles();
  const isLoading = useSelector(selectIsDashboardLoading);
  return (
    <>
      <Spinner show={isLoading} />
      <PageLayout>
        <div className={classes.container}>
          {children}
          <Copyright color="blue">
            Copyright 2020 ZERO TO THREE. All rights reserved.
          </Copyright>
        </div>
      </PageLayout>
    </>
  );
};

export default Dashboard;
